import {Component, EventEmitter, Input, Output} from "@angular/core";
import {FactoryService} from "../../../services/factory.service";
import {IDocument} from "../../../interfaces/document.definition";
declare var $: any;


@Component({
  selector: "go-wrapper",
  templateUrl: "./go-wrapper.component.html"
})


export class GoWrapperComponent {
  @Input() title: string;
  @Input() document: IDocument;
  @Input() componentType: string;

  @Output() onComponentRemoved = new EventEmitter();


  constructor(private factoryService: FactoryService) {
  }


  onCheckboxUpdated(value: boolean) {
    if (value) {
      this.factoryService.gameObjectUtils.initializeComponent(this.document, this.componentType);
    } else {
      this.factoryService.gameObjectUtils.removeComponent(this.document, this.componentType);
      this.onComponentRemoved.emit();
    }
  }


  get contentVisible(): boolean {
    let key = `${this.componentType}_hidden`;
    let v = this.document.admin[key];
    return typeof v === "undefined" || v === true;
  }


  onToggleClick() {
    let key = `${this.componentType}_hidden`;
    let v = this.document.admin[key];
    if (typeof v === "undefined") {
      this.document.admin[key] = false;
    } else {
      this.document.admin[key] = !v;
    }
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-wrapper/go-wrapper.component.ts